import React from 'react';
import { withParentSize } from '@visx/responsive';
import ParticipationTree from './ParticipationTree';

const Participation = ({ parentWidth, ...props }) => {
  return <ParticipationTree width={parentWidth} {...props} />;
};

export default withParentSize(Participation);
